export default "__VITE_ASSET__BO1OkLGW__"